import { render } from "./SectionNewsHorisontal.vue?vue&type=template&id=668d1a87&scoped=true"
import script from "./SectionNewsHorisontal.vue?vue&type=script&lang=js"
export * from "./SectionNewsHorisontal.vue?vue&type=script&lang=js"

import "./SectionNewsHorisontal.vue?vue&type=style&index=0&id=668d1a87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668d1a87"]])

export default __exports__